import jwt_decode from "jwt-decode";
import moment from "moment";

const tokenName = "proficontrolToken"
const setToken = (token: string) => {
    try {
        window.localStorage.setItem(tokenName, token);
    } catch (e) {
    }
}

const getToken = () => {
    try {
        return window.localStorage.getItem(tokenName) ?? '';
    } catch (e) {
        return '';
    }
}

const hasActiveToken = () => {
    const token = getToken();

    if (!token) return false;

    const {nbf, exp} = jwt_decode(token)

    if (!nbf) return false;

    const currentTime = moment().unix();

    return currentTime > nbf && (!exp || currentTime < exp);
}

const removeToken = () => {
    try {
        window.localStorage.removeItem(tokenName);
    } catch (e) {/*Ignored*/
    }
}

export {
    setToken,
    getToken,
    removeToken,
    hasActiveToken
}
